import React, { useState } from 'react';
import { Button, Text, View } from "../../Components/Themed"
import type { PlayerSquareProps, SquaresCompetitionProps } from "../../types"
import { useColors } from '../../constants/useColors';
import { Icons } from '../../Components';
import { FlatList } from 'react-native';

type SquaresRowProps = {
    market_type:'FOR_MONEY'|'FREE',
    squares_competition:SquaresCompetitionProps,
    width:number
}

const SquaresRow = ({ market_type, squares_competition, width }:SquaresRowProps) => {
    const Colors = useColors();
    const [ expanded, setExpanded ] = useState(false);
    const cl = market_type == 'FOR_MONEY' ? '$' : 'E'

    const renderSquares = (data:{item:PlayerSquareProps, index:number}) => {
        console.log(data.item)
        return (
            <View>
                <Text>SQUARE</Text>
            </View>
        )
    }

    return (
        <View>
            <View type='row' style={{ padding:10, borderBottomWidth:1, borderColor:Colors.borders.light, flexWrap:'wrap' }}>
                <Icons.SquaresIcon size={22} color={Colors.text.h1} />
                <Button transparent style={{ borderRadius:0, padding:0, borderLeftWidth:1, borderColor:Colors.borders.light, flexGrow:1, marginLeft:6, paddingLeft:6, minWidth:75 }} onPress={() => setExpanded(!expanded)}>
                    <Text theme='h1' style={{ maxWidth:width * 0.55 }}>{squares_competition.sq_comp_name}</Text>
                    <Text theme='light' style={{ marginTop:3 }} color={Colors.text.action}>See My Squares</Text>
                </Button>
                <View style={{ margin:5, minWidth:40, justifyContent:'center', alignItems:'center' }}>
                    <Text theme='h1'>{cl}{(0).toFixed(2)}</Text>
                    <Text theme='light'>Risk</Text>
                </View>
                
            </View>
            {expanded ?
            <View transparent style={{ padding:10 }}>
                <FlatList
                    data={[]}
                    renderItem={renderSquares}
                    key={`square_${squares_competition.sq_comp_id}_list`}
                    />
            </View>
            :<></>}
        </View>
    )
}

export default SquaresRow